import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import DiagnosisResultList from './DiagnosisResultList';
import DiagnosisPhotoList from './DiagnosisPhotoList';
import DiagnosisCompare from './DiagnosisCompare';

// 画面遷移作成
const MainStack = createNativeStackNavigator();

/** ================================
*  AI診断画面ナビゲーション
*  ================================*/
export default function DiagnoseNavigator() {
  return (
    <MainStack.Navigator screenOptions={{ headerShown: false }}>
      <MainStack.Screen name="DiagnosisResultList" component={DiagnosisResultList} options={{ title: '診断結果一覧' }} />
      <MainStack.Screen name="DiagnosisPhotoList" component={DiagnosisPhotoList} options={{ title: '撮影画像一覧' }} />
      <MainStack.Screen name="DiagnosisCompare" component={DiagnosisCompare} options={{ title: '過去データ比較' }} />
    </MainStack.Navigator>
  );
}
